import { useState } from "react";
import "./App.css";

const App = () => {
  const [tile, setTile] = useState();
  const [size, setSize] = useState(300);
  const [saturation, setSaturation] = useState(100);
  const [saturationRed, setSaturationRed] = useState(100);
  const [saturationGreen, setSaturationGreen] = useState(100);
  const [saturationBlue, setSaturationBlue] = useState(100);
  const [blur, setBlur] = useState(0);
  const [hueRotation, setHueRotation] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [invert, setInvert] = useState(0);
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");

  const handleTile = (event) => {
    setTile(event.target.value);
  };

  const handleResize = (event) => {
    setSize(event.target.value);
  };

  const handleSaturationChange = (event) => {
    setSaturation(event.target.value);
  };

  const handleSaturationRedChange = (event) => {
    setSaturationRed(event.target.value);
  };

  const handleSaturationGreenChange = (event) => {
    setSaturationGreen(event.target.value);
  };

  const handleSaturationBlueChange = (event) => {
    setSaturationBlue(event.target.value);
  };

  const handleBlurChange = (event) => {
    setBlur(event.target.value);
  };

  const handleHueRotationChange = (event) => {
    setHueRotation(event.target.value);
  };

  const handleOpacityChange = (event) => {
    setOpacity(event.target.value);
  };

  const handleInvertChange = (event) => {
    setInvert(event.target.value);
  };

  const handleBackgroundColorChange = (event) => {
    setBackgroundColor(event.target.value);
  };

  return (
    <div style={{ backgroundColor: backgroundColor }}>
      <div
        className="nav"
        style={{
          display: "flex",
          flexWrap: "wrap",
          color: "rgb(255, 255, 255)",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          padding: ".5em",
        }}
      >
        <div className="input">
          <label>Image URL:</label>
          <br />
          <input
            type="text"
            onChange={handleTile}
            placeholder="Paste URL..."
          ></input>
        </div>
        <div className="input">
          <label>background-size: {size}px;</label>
          <br />
          <input
            onChange={handleResize}
            type="range"
            min="10"
            max="1000"
          ></input>
        </div>
        <div className="input">
          <label>filter: saturate({saturation}%);</label>
          <br />
          <input
            onChange={handleSaturationChange}
            type="range"
            min="0"
            max="200"
          ></input>
        </div>
        <div className="input">
          <label>Saturation Red: {saturationRed}%</label>
          <br />
          <input
            onChange={handleSaturationRedChange}
            type="range"
            min="0"
            max="200"
          ></input>
        </div>
        <div className="input">
          <label>Saturation Green: {saturationGreen}%</label>
          <br />
          <input
            onChange={handleSaturationGreenChange}
            type="range"
            min="0"
            max="200"
          ></input>
        </div>
        <div className="input">
          <label>Saturation Blue: {saturationBlue}%</label>
          <br />
          <input
            onChange={handleSaturationBlueChange}
            type="range"
            min="0"
            max="200"
          ></input>
        </div>
        <div className="input">
          <label>Blur: {blur}px</label>
          <br />
          <input
            onChange={handleBlurChange}
            type="range"
            min="0"
            max="10"
          ></input>
        </div>
        <div className="input">
          <label>Hue Rotation: {hueRotation}deg</label>
          <br />
          <input
            onChange={handleHueRotationChange}
            type="range"
            min="0"
            max="360"
          ></input>
        </div>
        <div className="input">
          <label>Opacity: {opacity}</label>
          <br />
          <input
            onChange={handleOpacityChange}
            type="range"
            min="0"
            max="1"
            step="0.1"
          ></input>
        </div>
        <div className="input">
          <label>Invert: {invert}</label>
          <br />
          <input
            onChange={handleInvertChange}
            type="range"
            min="0"
            max="1"
            step="0.1"
          ></input>
        </div>
        <div className="input">
          <label>Background Color:</label>
          <br />
          <input onChange={handleBackgroundColorChange} type="color"></input>
        </div>
      </div>
      <div
        className="back"
        style={{
          backgroundImage: `url(${tile})`,
          backgroundSize: `${size}px`,
          height: "100vh",
          filter: `saturate(${saturation}%) blur(${blur}px) hue-rotate(${hueRotation}deg) opacity(${opacity}) invert(${invert}) saturate(${saturationRed}%) saturate(${saturationGreen}%) saturate(${saturationBlue}%)`,
        }}
      ></div>
    </div>
  );
};

export default App;
